import { PropsWithChildren } from 'react';
import { TagProps } from './types';
import { MinimalIconProps } from '@ardoq/icons';

const getIconProps = (
  { iconName, rightIconName, leftIcon, rightIcon }: PropsWithChildren<TagProps>,
  side: 'left' | 'right'
): MinimalIconProps | undefined => {
  if (side === 'left') {
    return iconName
      ? {
          name: iconName,
        }
      : leftIcon
        ? leftIcon
        : undefined;
  }
  return rightIconName
    ? {
        name: rightIconName,
      }
    : rightIcon
      ? rightIcon
      : undefined;
};

export const tagOperations = {
  getIconProps,
};
